import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppInput from '@nxsys/components/AppInput';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import { Ref, useImperativeHandle } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '@nxsys/store';
import StepTitle from './StepTitle';

export type SendCreationLinkValues = {
  email: string;
  recipientName?: string;
};

export type SendCreationLinkFormRef = {
  isValidForm: () => Promise<boolean>;
  getValues: () => SendCreationLinkValues;
  resetFields: () => void;
};

type Props = {
  formRef: Ref<SendCreationLinkFormRef>;
  initialValues: Partial<SendCreationLinkValues>;
};

const SendCreationLink: React.FC<Props> = ({ formRef, initialValues }) => {
  const { isBureau } = useSelector((state: AppState) => state.appStore);
  const [form] = Form.useForm<SendCreationLinkValues>();

  useImperativeHandle(formRef, () => ({
    isValidForm: async () => {
      try {
        await form.validateFields();
        return true;
      } catch (error) {
        return false;
      }
    },
    getValues() {
      return form.getFieldsValue(true);
    },
    resetFields() {
      form.resetFields();
    },
  }));

  const onFinish: FormProps['onFinish'] = async (values) => {
    console.info('values', values);
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div className="SendCreationLink">
      <StepTitle
        title={isBureau ? 'Send Employer Creation Link' : 'Send Company Creation Link'}
        description={isBureau ? 'Enter the email address to send the employer creation link to.' : 'Enter the email address to send the company creation link to.'}
      />

      <div className="mt-[16px]">
        <AppFormContainer
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={initialValues}
          layout="vertical"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
        >
          <Form.Item
            name="recipientName"
            label="Name"
          >
            <AppInput placeholder="Enter recipient name" />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Please enter an email address' },
              { type: 'email', message: 'Please enter a valid email address' },
            ]}
          >
            <AppInput
              placeholder="Enter email address"
              allowCapitalize={false}
            />
          </Form.Item>
        </AppFormContainer>
      </div>
    </div>
  );
};

export default SendCreationLink;
